module.exports = __webpack_public_path__ + "static/media/graph-minimize.6a4ed43c.svg";